/**
 * P-10b (D-69) — the employee's monthly attendance approval. Pure, no React.
 *
 * The request appears automatically from the 1st of the month for the
 * PREVIOUS month (the first-of-month job creates the summary and notifies),
 * and stays only until the employee approves — it is not a permanent card at
 * the top of the attendance screen (99540). Reopened by an OTE manager, it is
 * pending again and comes back.
 */

export interface MonthlySummaryLike {
  employee_confirmed?: boolean | null;
  locked?: boolean | null;
}

/** Last month still waits for the employee's one-click approval. */
export function isMonthlyApprovalPending(summary: MonthlySummaryLike | null | undefined): boolean {
  return !!summary && !summary.employee_confirmed && !summary.locked;
}

/** BQ-065 (D-69): the OTE manager's reopen of an approved month needs a reason of 3+ characters (as the server). */
export const MONTH_REOPEN_MIN_REASON = 3;
export function canSubmitMonthReopen(reason: string | null | undefined): boolean {
  return String(reason ?? '').trim().length >= MONTH_REOPEN_MIN_REASON;
}

/**
 * "החודש <X> נפתח מחדש: <סיבה>" — the month key and reason of a reopen
 * notification, or null when the row carries no reason (older rows keep their
 * plain label).
 */
export function monthReopenedParams(
  metadata: Record<string, unknown> | null | undefined,
): { monthKey: string; reason: string } | null {
  const reason = typeof metadata?.reason === 'string' ? metadata.reason.trim() : '';
  const monthKey = typeof metadata?.month_year === 'string' ? metadata.month_year : '';
  if (!reason || !monthKey) return null;
  return { monthKey, reason };
}
